export default __webpack_public_path__ + "static/media/standby-always-on.4fb910ec.svg";